import { render, staticRenderFns } from "./CodeEditor.vue?vue&type=template&id=7c27cba2&scoped=true&"
import script from "./CodeEditor.vue?vue&type=script&lang=ts&"
export * from "./CodeEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CodeEditor.vue?vue&type=style&index=0&id=7c27cba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c27cba2",
  null
  
)

export default component.exports